<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 23.0001C18.299 23.0001 23 18.2991 23 12.5001C23 6.70113 18.299 2.00012 12.5 2.00012C6.70101 2.00012 2 6.70113 2 12.5001C2 18.2991 6.70101 23.0001 12.5 23.0001ZM7.70725 18.7072L11.7072 14.7072L10.293 13.293L6.29304 17.293L7.70725 18.7072Z"
      fill="#999999"
    />
    <circle cx="14" cy="11.0001" r="4" stroke="white" stroke-width="2" />
  </svg>
</template>
